var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step"},[_c('el-steps',{attrs:{"active":_vm.$store.getters.denAct,"simple":""}},[_c('el-step',{attrs:{"title":"病情诊断"}}),_c('el-step',{attrs:{"title":"病情评估"}}),_c('el-step',{attrs:{"title":"预约诊所"}}),_c('el-step',{attrs:{"title":"模型采集"}}),_c('el-step',{attrs:{"title":"选择材质"}}),_c('el-step',{attrs:{"title":"手术报告"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }